import { render, staticRenderFns } from "./yyzs.vue?vue&type=template&id=0567daf2&scoped=true&"
import script from "./yyzs.vue?vue&type=script&lang=js&"
export * from "./yyzs.vue?vue&type=script&lang=js&"
import style0 from "./yyzs.vue?vue&type=style&index=0&id=0567daf2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0567daf2",
  null
  
)

export default component.exports